/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.spinner-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.32);z-index:102}.spinner-text[_ngcontent-%COMP%]{color:#f5f5f5;margin-top:20px;padding:4px;border-radius:8px;background-color:rgba(1,89,161,.5)}"];
export { styles as styles };
